module.exports = __webpack_public_path__ + "img/gtsfly-logo-mobile.569991fb.svg";